import * as api from '../api/roles';
import * as formApi from '../api/eventform';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'EVENTS/ROLE';

export const ROLES_FETCH_START = `${namespace}/ROLES_FETCH_START`;
export const ROLES_FETCH_SUCCESS = `${namespace}/ROLES_FETCH_SUCCESS`;
export const ROLES_FETCH_ERROR = `${namespace}/ROLES_FETCH_ERROR`;

export const FORM_ASSOCS_FETCH_START = `${namespace}/FORM_ASSOCS_FETCH_START`;
export const FORM_ASSOCS_FETCH_SUCCESS = `${namespace}/FORM_ASSOCS_FETCH_SUCCESS`;
export const FORM_ASSOCS_FETCH_ERROR = `${namespace}/FORM_ASSOCS_FETCH_ERROR`;

export const EVENT_FORMS_FETCH_START = `${namespace}/EVENT_FORMS_FETCH_START`;
export const EVENT_FORMS_FETCH_SUCCESS = `${namespace}/EVENT_FORMS_FETCH_SUCCESS`;
export const EVENT_FORMS_FETCH_ERROR = `${namespace}/EVENT_FORMS_FETCH_ERROR`;

export const FORM_ASSOC_CREATE_START = `${namespace}/FORM_ASSOC_CREATE_START`;
export const FORM_ASSOC_CREATE_SUCCESS = `${namespace}/FORM_ASSOC_CREATE_SUCCESS`;
export const FORM_ASSOC_CREATE_ERROR = `${namespace}/FORM_ASSOC_CREATE_ERROR`;

export const FORM_ASSOC_DELETE_START = `${namespace}/FORM_ASSOC_DELETE_START`;
export const FORM_ASSOC_DELETE_SUCCESS = `${namespace}/FORM_ASSOC_DELETE_SUCCESS`;
export const FORM_ASSOC_DELETE_ERROR = `${namespace}/FORM_ASSOC_DELETE_ERROR`;

export const FORM_ASSOCS_DELETE_START = `${namespace}/FORM_ASSOCS_DELETE_START`;
export const FORM_ASSOCS_DELETE_SUCCESS = `${namespace}/FORM_ASSOCS_DELETE_SUCCESS`;
export const FORM_ASSOCS_DELETE_ERROR = `${namespace}/FORM_ASSOCS_DELETE_ERROR`;

export const fetchRoles = makeApiActionCreatorV3(
  api.fetchRoles,
  ROLES_FETCH_START,
  ROLES_FETCH_SUCCESS,
  ROLES_FETCH_ERROR,
);

export const fetchFormAssocs = makeApiActionCreatorV3(
  api.fetchFormAssocs,
  FORM_ASSOCS_FETCH_START,
  FORM_ASSOCS_FETCH_SUCCESS,
  FORM_ASSOCS_FETCH_ERROR,
);

export const fetchEventForms = makeApiActionCreatorV3(
  formApi.fetchEventForms,
  EVENT_FORMS_FETCH_START,
  EVENT_FORMS_FETCH_SUCCESS,
  EVENT_FORMS_FETCH_ERROR,
);

export const createFormAssoc = makeApiActionCreatorV3(
  api.createFormAssoc,
  FORM_ASSOC_CREATE_START,
  FORM_ASSOC_CREATE_SUCCESS,
  FORM_ASSOC_CREATE_ERROR,
);

export const deleteFormAssoc = makeApiActionCreatorV3(
  api.deleteFormAssoc,
  FORM_ASSOC_DELETE_START,
  FORM_ASSOC_DELETE_SUCCESS,
  FORM_ASSOC_DELETE_ERROR,
);

export const deleteFormAssocs = makeApiActionCreatorV3(
  api.deleteFormAssocs,
  FORM_ASSOCS_DELETE_START,
  FORM_ASSOCS_DELETE_SUCCESS,
  FORM_ASSOCS_DELETE_ERROR,
);
